import styled from 'styled-components'

import { VideoPlayer } from 'components/atoms'
import * as S from 'components/templates/styled'
import { theme } from 'styles/theme'
import { getSize } from 'utils'

export const Container = styled(S.Container)``

export const Video = styled(VideoPlayer)`
  position: fixed;
  right: 50%;
  bottom: 50%;
  transform: translate(50%, 50%);
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: ${theme.colors.primaryBlack};
`

export const Description = styled.div`
  position: absolute;
  bottom: ${getSize(100)};
  width: ${getSize(585)};
  height: max-content;
  max-height: ${getSize(900)};
  padding: ${getSize(64)};
  box-sizing: border-box;
  color: ${theme.colors.white};
  font-weight: 600;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 20;
    -webkit-box-orient: vertical;
    margin: 0;
  }

  @media (max-aspect-ratio: 1/1) {
    bottom: ${getSize(130)};
  }
`
export const CloudFooter = styled.div``
